export default IconBong => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bong" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M13 3v8.416c.134 .059 .265 .123 .393 .193l3.607 -3.609l2 2l-3.608 3.608a5 5 0 1 1 -6.392 -2.192v-8.416h4z" />
  <path d="M8 3h6" />
  <path d="M6.1 17h9.8" />
</svg>`;